import React, { FC } from 'react';
import Button from '../../../../components/Button';
import './styles.scss';
import { Props } from './typing';
import { useDispatch } from 'react-redux';
import { logOutAction } from '../../../../redux/actions/login';

const SomethingWentWrong: FC<Props> = (): JSX.Element => {
  const dispatch = useDispatch();
  return (
    <div className='dashboard-not-available'>
      <h5>Something Went Wrong</h5>

      <Button
        btnStyleClass='login-primary-button'
        label={'Logout'}
        enable={true}
        type='submit'
        onClick={() => {
          dispatch(logOutAction());
        }}
      />
    </div>
  );
};

export default SomethingWentWrong;
